var _defs, _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "iconShadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 2,
    floodColor: "black",
    floodOpacity: 0.8
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 3,
    height: 3,
    fill: "white",
    opacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 3,
    height: 3,
    fill: "white",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    filter: "url(#iconShadow)",
    d: "M12 0.5C5.65 0.5 0.5 5.65 0.5 12C0.5 17.08 3.87 21.34 8.53 22.88C9.12 22.99 9.32 22.63 9.32 22.32C9.32 22.04 9.31 21.2 9.3 20.17C6 20.82 5.31 18.59 5.31 18.59C4.77 17.2 3.97 16.83 3.97 16.83C2.87 16.06 4.05 16.08 4.05 16.08C5.27 16.17 5.92 17.33 5.92 17.33C7 19.14 8.75 18.64 9.45 18.36C9.56 17.58 9.87 17.06 10.21 16.77C7.57 16.48 4.79 15.47 4.79 10.96C4.79 9.67 5.25 8.63 6.02 7.81C5.9 7.52 5.5 6.33 6.13 4.76C6.13 4.76 7.08 4.47 9.29 6.02C10.2 5.76 11.17 5.63 12.14 5.63C13.11 5.63 14.08 5.76 14.99 6.02C17.2 4.47 18.15 4.76 18.15 4.76C18.78 6.33 18.38 7.52 18.26 7.81C19.03 8.63 19.49 9.67 19.49 10.96C19.49 15.48 16.7 16.47 14.06 16.76C14.5 17.13 14.9 17.85 14.9 18.95C14.9 20.53 14.89 21.85 14.89 22.32C14.89 22.63 15.09 23 15.69 22.88C20.35 21.34 23.72 17.08 23.72 12C23.72 5.65 18.57 0.5 12 0.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon4);
export default __webpack_public_path__ + "static/media/nav-icon4.66b2998e1dc367b4bc3ff3225fc8ae33.svg";
export { ForwardRef as ReactComponent };